'use client'

import { useContext, useEffect, useState } from 'react'

import { themes as Theme } from '@/Theme'
import { getPlatform, Platforms } from '@/utils/getPlatform'
import { ThemeContext } from '@/utils/themeContext'

import type { Platform } from '@/utils/getPlatform'

const TWIST_PLATFORM_INSTALL_LINKS: Record<Platform, string> = {
    [Platforms.macOS]: 'https://twist.com/mac_app',
    [Platforms.iOS]: 'https://apps.apple.com/us/app/twist-mindful-team-communication/id1126800020',
    [Platforms.android]: 'https://play.google.com/store/apps/details?id=com.twistapp&hl=en',
    [Platforms.windows]: 'https://twist.com/windows_app',
    [Platforms.linux]: 'https://twist.com/linux_app/appimage',
    [Platforms.unknown]: 'https://twist.com/downloads',
}

const TODOIST_PLATFORM_INSTALL_LINKS: Record<Platform, string> = {
    [Platforms.macOS]:
        'https://geo.itunes.apple.com/us/app/todoist-to-do-list-task-manager/id585829637?mt=12',
    [Platforms.iOS]:
        'https://geo.itunes.apple.com/us/app/todoist-to-do-list-task-manager/id572688855',
    [Platforms.android]: 'https://play.google.com/store/apps/details?id=com.todoist',
    [Platforms.windows]: 'https://todoist.com/windows_app',
    [Platforms.linux]: 'https://todoist.com/downloads/linux',
    [Platforms.unknown]: 'https://todoist.com/downloads',
}

export class DownloadTitles {
    localizedTitles: Record<Platform, string>

    constructor(
        macOs: string,
        iOS: string,
        android: string,
        windows: string,
        linux: string,
        all: string,
    ) {
        this.localizedTitles = {
            [Platforms.macOS]: macOs,
            [Platforms.iOS]: iOS,
            [Platforms.android]: android,
            [Platforms.windows]: windows,
            [Platforms.linux]: linux,
            [Platforms.unknown]: all,
        }
    }
}

type DownloadProps = {
    href: string
    title: string
}
export function useDownloadProps(titles: DownloadTitles) {
    const { theme } = useContext(ThemeContext)

    const [platform, setPlatform] = useState<Platform>('unknown')
    const [props, setProps] = useState<DownloadProps>({ href: '', title: '' })

    const links =
        theme === Theme.todoist ? TODOIST_PLATFORM_INSTALL_LINKS : TWIST_PLATFORM_INSTALL_LINKS

    useEffect(() => {
        const navigator = window.navigator
        setPlatform(getPlatform(navigator.userAgent, navigator.platform))
    }, [])

    useEffect(() => {
        setProps({ href: links[platform], title: titles.localizedTitles[platform] })
    }, [platform, links, titles])

    return props
}
